import React from 'react';
import PropTypes from 'prop-types';
import {FormattedMessage} from 'react-intl';

const Switcher = ({ value, onChange, disabled = false }) => {
  const handleClick = () => {
    if (!disabled) {
      onChange(!value);
    }
  };

  return (
    <div className="ui-radio-block">
      <span className="ui-radio-label"/>
      <button
        className={
          "ui-radio ui-radio--small" +
          (value ? " ui-radio--checked" : "") +
          (disabled ? " ui-radio--disabled" : "")
        }
        onClick={handleClick}
      >
        <span className="ui-radio-circle"/>
        <span className="ui-radio-text ui-radio-text--yes">
          <FormattedMessage id="radioButton.on"/>
        </span>
        <span className="ui-radio-text ui-radio-text--no">
          <FormattedMessage id="radioButton.off"/>
        </span>
      </button>
    </div>
  );
};

Switcher.propTypes = {
  value: PropTypes.bool.isRequired,
  onChange: PropTypes.func.isRequired,
  disabled: PropTypes.bool
};

export default Switcher;
